/**
 * Prefer server message from API error bodies (OAuth error_description, ProblemDetails,
 * ASP.NET Identity errors, ErrorResponseViewModel, etc.).
 *
 * Supports both raw axios errors (`error.response.data`) and RTK Query / unwrap
 * (`error.data`).
 */
export function getAxiosErrorMessage(error, fallback = 'Something went wrong.') {
  const data = error?.data ?? error?.response?.data;

  if (data == null || data === '') {
    const msg = error?.message;
    if (typeof msg === 'string' && !/^Request failed with status code \d+$/.test(msg)) {
      return msg;
    }
    return fallback;
  }

  if (typeof data === 'string') {
    return data || fallback;
  }

  if (Array.isArray(data)) {
    if (data.length === 0) return fallback;
    const parts = data.map((item) => {
      if (item == null) return '';
      if (typeof item === 'string') return item;
      if (typeof item === 'object') {
        return item.description ?? item.message ?? '';
      }
      return String(item);
    }).filter(Boolean);
    if (parts.length > 0) return parts.join(' ');
    return fallback;
  }

  if (typeof data === 'object' && data !== null) {
    if (data.error_description != null && data.error_description !== '') {
      return String(data.error_description);
    }
    if (data.ErrorMessage != null && data.ErrorMessage !== '') {
      return String(data.ErrorMessage);
    }
    if (data.detail != null && data.detail !== '') {
      return String(data.detail);
    }
    if (data.message != null && data.message !== '') {
      return String(data.message);
    }
    if (data.errorMessage != null && data.errorMessage !== '') {
      return String(data.errorMessage);
    }
    if (data.title != null && data.title !== '') {
      return String(data.title);
    }
    if (data.error != null && data.error !== '') {
      return String(data.error);
    }
  }

  return fallback;
}
